import React, { useEffect, useState } from "react";
import { useAuditorGetShareClient, useAuditorAcceptShareClient, useAuditorRemoveShareClient } from "../../../index";
import { Button, TextButton, Tooltip, Widget } from "../../../styled";
import { Table, TableHeader, TableBody, TableBodyNoDataWrapper, TableLoadingWrapper } from "../../../styled";
import "./AuditorAccessManager.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faSpinner } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
const AuditorAccessManager = ({
  activeShare,
  handleRowSelect
}) => {
  const [isLoading, setLoading] = useState(false);
  const [isRefreshLoading, setRefreshLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [getShareDetails] = useAuditorGetShareClient();
  const [acceptShare] = useAuditorAcceptShareClient();
  const [removeShare] = useAuditorRemoveShareClient();
  useEffect(() => {
    setLoading(true);
    getShares();
  }, []);
  const getShares = async () => {
    // setLoading(true)

    const resp = await getShareDetails();
    const shares = resp.shares.map((share, index) => {
      return {
        key: index,
        name: {
          name: share.share.name,
          account_key: share.share.account_key
        },
        last_modified: share.share.last_status_datetime,
        share_id: share.share.share_id,
        status: {
          access_state: share.share.share_state,
          loading: false
        },
        action: {
          access_state: share.share.share_state,
          loading: false
        }
      };
    });
    setRows(shares);
    setLoading(false);
    setRefreshLoading(false);
  };
  const setShareActionLoading = (shareId, loading) => {
    const index = rows.findIndex(row => row.share_id === shareId);
    rows[index].action.loading = loading;
    setRows([...rows]);
  };
  const handleAcceptShare = async record => {
    const resp = await acceptShare({
      share_id: record.share_id
    });
    if (resp._http_status === 200) {
      await getShares();
    }
  };
  const handleRemoveShare = async record => {
    const resp = await removeShare({
      share_id: record.share_id
    });
    if (resp._http_status === 200) {
      await getShares();
    }
  };
  const columns = [{
    dataKey: "name",
    label: "Name",
    columnStyles: {
      minWidth: "400px",
      width: "50%"
    },
    renderCell: (name, record) => {
      return /*#__PURE__*/React.createElement("div", null, name.name, /*#__PURE__*/React.createElement("p", {
        className: "access-table-subtext"
      }, name.account_key));
    }
  }, {
    dataKey: "status",
    label: "Access Status",
    columnStyles: {
      minWidth: "250px",
      width: "25%"
    },
    // textTransform: 'capitalize'
    renderCell: (status, record) => {
      const accessStateMap = {
        request_sent: "Requested",
        declined: "Declined",
        detached: "Detached",
        enabled: "Enabled",
        disabled: "Disabled by Customer",
        revoked: "Revoked by Customer"
      };
      return /*#__PURE__*/React.createElement("span", null, accessStateMap[status.access_state] ? accessStateMap[status.access_state] : status.access_state, status.access_state === "disabled" ? /*#__PURE__*/React.createElement("p", {
        className: "access-table-subtext"
      }, "They can re-enable access") : null, status.access_state === "enabled" ? /*#__PURE__*/React.createElement(TextButton, {
        onClick: () => handleRowSelect({
          share_id: record.share_id,
          name: record.name.name,
          account_key: record.name.account_key
        }),
        children: `${activeShare.share_id === record.share_id ? 'Hide' : 'View'} Details`
      }) : null);
    }
  }, {
    dataKey: "last_modified",
    label: "Last Modified",
    columnStyles: {
      minWidth: "75px",
      width: "50%"
    },
    renderCell: (lastModified, record) => {
      const dt = moment.utc(lastModified);
      const time = dt.local().format("h:mm:ss A");
      const date = dt.local().format("M/D/YYYY");
      return /*#__PURE__*/React.createElement("span", null, time, /*#__PURE__*/React.createElement("p", {
        className: "access-table-subtext"
      }, date));
    }
  }, {
    dataKey: "action",
    label: "Actions",
    columnStyles: {
      minWidth: "75px",
      width: "50%"
    },
    renderCell: (action, record) => {
      switch (action.access_state) {
        case 'request_sent':
          {
            return /*#__PURE__*/React.createElement("div", null, record.action.loading ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              className: "spinner-icon",
              icon: faSpinner,
              size: "1x",
              pulse: record.action.loading
            }) : null, /*#__PURE__*/React.createElement(TextButton, {
              disabled: record.action.loading,
              onClick: () => {
                setShareActionLoading(record.share_id, true);
                handleAcceptShare(record);
              },
              children: 'Accept'
            }), /*#__PURE__*/React.createElement(TextButton, {
              disabled: record.action.loading,
              onClick: () => {
                setShareActionLoading(record.share_id, true);
                handleRemoveShare(record);
              },
              children: 'Decline'
            }));
          }
        case 'enabled' || 'disabled':
          {
            return /*#__PURE__*/React.createElement("div", null, record.action.loading ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              className: "spinner-icon",
              icon: faSpinner,
              size: "1x",
              pulse: record.action.loading
            }) : null, /*#__PURE__*/React.createElement(TextButton, {
              disabled: record.action.loading,
              onClick: () => {
                setShareActionLoading(record.share_id, true);
                handleRemoveShare(record);
              },
              children: 'Remove Sharing'
            }));
          }
        default:
          {
            return /*#__PURE__*/React.createElement("div", null, record.action.loading ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              className: "spinner-icon",
              icon: faSpinner,
              size: "1x",
              pulse: record.action.loading
            }) : null, /*#__PURE__*/React.createElement(TextButton, {
              disabled: record.action.loading,
              onClick: () => {
                setShareActionLoading(record.share_id, true);
                handleRemoveShare(record);
              },
              children: 'Remove from list'
            }));
          }
      }
    }
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "access-manager-container"
  }, /*#__PURE__*/React.createElement(Widget, {
    title: "Access Management",
    titleRowChildren: /*#__PURE__*/React.createElement("div", {
      className: "access-manager-action-refresh"
    }, /*#__PURE__*/React.createElement(Tooltip, {
      tooltipChildren: /*#__PURE__*/React.createElement("p", null, "Refresh"),
      children: /*#__PURE__*/React.createElement(Button, {
        disabled: isRefreshLoading,
        styleType: "primary",
        onClick: () => {
          setLoading(true);
          setRefreshLoading(true);
          getShares();
          handleRowSelect(activeShare);
        },
        children: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faArrowsRotate,
          size: "1x",
          spin: isRefreshLoading
        })
      })
    }))
  }, /*#__PURE__*/React.createElement(TableLoadingWrapper, {
    columns: columns,
    rows: rows,
    showRowLoading: isLoading
  }, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHeader, null), /*#__PURE__*/React.createElement(TableBodyNoDataWrapper, null, /*#__PURE__*/React.createElement(TableBody, null))))));
};
export { AuditorAccessManager };